export function concatWithComma(str, num) {
  let result = "";
  for (let i = 0; i < num; i++) {
    result += str;
    if (i !== num - 1) {
      result += ",";
    }
  }
  return result;
}

export function concatArrayOfElementsWithComma(arr) {
  let result = "";
  for (let i = 0; i < arr.length; i++) {
    if (arr[i] !== "") {
      if (result !== "") {
        result += ",";
      }
      result += arr[i];
    }
  }
  return result;
}
